// import { AssetsManagement, AuthenticationManagement, DashboardManagement, UploadManagement } from 'pages';
import React from 'react';

const AssetsManagement = React.lazy(() => import('pages/AssetsManagement'));
const AuthenticationManagement = React.lazy(() => import('pages/AuthenticationManagement'));
const DashboardManagement = React.lazy(() => import('pages/DashboardManagement'));
const UploadManagement = React.lazy(() => import('pages/UploadManagement'));
const InfraManagement = React.lazy(() => import('pages/InfraManagement'));
const DistributionAnalytics = React.lazy(() => import('pages/AnalyticsManagement/distribution'));
const EngagementAnalytics = React.lazy(() => import('pages/AnalyticsManagement/engagement'));
const EngagementAnalyticsDev = React.lazy(() => import('pages/AnalyticsManagement/engagementDev'));
const SkillsAnalytics = React.lazy(() => import('pages/AnalyticsManagement/skills'));
const LeadsManagement = React.lazy(() => import('pages/LeadsManagement'));
const ConversionUpdate = React.lazy(() => import('pages/DashboardManagement/create'));
const UploadUpdate = React.lazy(() => import('pages/UploadManagement/create'));
const CurationManagement = React.lazy(() => import('pages/CurationManagement/CurationManagement'));
const CoursesManagement = React.lazy(() => import('pages/CoursesManagement/CoursesManagement'));
const CoursesForm = React.lazy(() => import('pages/CoursesManagement/CoursesForm'));
const TrackManagement = React.lazy(() => import('pages/CoursesManagement/TrackManagement'));
const CurationForm = React.lazy(() => import('../pages/CurationManagement/containers/Curation/CurationForm'));
const CurationDetails = React.lazy(() => import('../pages/CurationManagement/containers/Curation/CurationDetails'));
const Settings = React.lazy(() => import('../pages/SettingsManagement/Settings'));
const FeedManagement = React.lazy(() => import('../pages/FeedManagement/FeedManagement'));
const FeedForm = React.lazy(() => import('../pages/FeedManagement/containers/Feed/FeedForm'));
const SocialFeedForm = React.lazy(() => import('../pages/FeedManagement/containers/SocialFeed/SocialFeedForm'));
const CustomizeSocialFeed = React.lazy(
  () => import('../pages/FeedManagement/containers/SocialFeed/customize/CustomizeSocialFeed')
);
const CustomizeFeed = React.lazy(() => import('../pages/FeedManagement/containers/Feed/CustomizeFeed'));
const SocialFeedSettings = React.lazy(() => import('../pages/FeedManagement/containers/SocialFeed/SocialFeedSettings'));
import { iconMapKeys } from '.icons';
export const pageRoutes = {
  private: [
    { component: DashboardManagement, path: '/call-to-action', title: 'Create and Organize CTAs' }, //allowedRoles: ["ADMIN"]
    {
      component: ConversionUpdate,
      path: '/call-to-action/dynamic',
      title: 'Add Dynamic URL Conversion',
      redirect: '/call-to-action'
    },
    {
      component: ConversionUpdate,
      path: '/call-to-action/fixed',
      title: 'New Fixed URL Conversion',
      redirect: '/call-to-action'
    },
    {
      component: ConversionUpdate,
      path: '/call-to-action/edit/:id',
      title: 'Edit Conversion',
      redirect: '/call-to-action'
    },
    // { component: ConversionUpdate, path: '/call-to-action/edit/form/:id', title:"XXX" },
    {
      component: UploadManagement,
      path: '/upload-approve',
      title: 'Upload and Moderate Content',
      topBarMenu: [
        {
          name: 'Approve',
          href: '/upload-approve?status=approve',
          queryParam: 'status',
          value: 'approve'
        },
        {
          name: 'Revision',
          href: '/upload-approve?status=revision',
          queryParam: 'status',
          value: 'revision'
        }
      ]
    },
    { component: AssetsManagement, path: '/assets', title: 'Manage and Modify Content' },
    { component: UploadUpdate, path: '/assets/edit-asset/:id', title: 'Edit Asset', redirect: '/assets' },
    { component: InfraManagement, path: '/infra', title: 'Infra' },
    { component: DistributionAnalytics, path: '/analytics/distribution', title: 'Monitor and Optimize Embeds' },
    {
      component:
        process.env.REACT_APP_API_BASE_URL !== 'https://api.dev.blinklink.io'
          ? EngagementAnalytics
          : EngagementAnalyticsDev,
      path: '/analytics/engagement',
      title: 'Track and Measure Performance'
    },
    { component: SkillsAnalytics, path: '/analytics/skills', title: 'Measure and Improve Learning' },
    // { component: AnalyticsManagement, path: '/analytics/:type', title:"XXX" },
    { component: LeadsManagement, path: '/leads' },
    {
      component: UploadUpdate,
      path: '/upload-approve/upload-asset',
      title: 'Single Asset Upload',
      redirect: '/upload-approve'
    },
    {
      component: UploadUpdate,
      path: '/upload-approve/edit-asset/:id',
      title: 'Edit Asset',
      redirect: '/upload-approve'
    },
    { component: CurationManagement, path: '/curations', title: 'Improve and Update Recommendations' },
    { component: CurationForm, path: '/curations/create', title: 'Add Curation', redirect: '/curations' },
    { component: CurationDetails, path: '/curations/:curationId', title: 'Curations', redirect: '/curations' },
    { component: CoursesManagement, path: '/courses', title: 'Create and Manage Courses' },
    { component: CoursesForm, path: '/courses/create', title: 'Add Course', redirect: '/courses' },
    { component: CoursesForm, path: '/courses/edit/:courseId', title: 'Edit Course', redirect: '/courses' },
    { component: TrackManagement, path: '/courses/:courseId/tracks', redirect: '/courses' },
    { component: Settings, path: '/settings', exact: false, title: 'Settings' },
    { component: FeedManagement, path: '/feeds', title: 'Create and Customize Feeds' },
    { component: SocialFeedForm, path: '/feeds/social/new', title: 'Create Social Feed', redirect: '/feeds' },
    {
      component: SocialFeedSettings,
      path: '/feeds/social/:socialFeedId/settings',
      title: 'Social Feed Settings',
      redirect: '/feeds'
    },
    {
      component: CustomizeSocialFeed,
      path: '/feeds/social/:socialFeedId/customize',
      title: 'Create and Customize Feeds',
      redirect: '/feeds'
    },
    { component: FeedForm, path: '/feeds/new', title: 'Create Feed', redirect: '/feeds' },
    { component: FeedForm, path: '/feeds/:feedId/edit', title: 'Update Feed', redirect: '/feeds' },
    { component: CustomizeFeed, path: '/feeds/:feedId/customize', title: 'Customize', redirect: '/feeds' }
  ],
  public: [
    { path: '/', component: AuthenticationManagement, section: 'login' },
    { path: '/login', component: AuthenticationManagement, section: 'login' },
    { path: '/register', component: AuthenticationManagement, section: 'register' },
    { path: '/country', component: AuthenticationManagement, section: 'country' },
    { path: '/company', component: AuthenticationManagement, section: 'company' },
    { path: '/thankyou', component: AuthenticationManagement, section: 'thankyou' },
    { path: '/forgot', component: AuthenticationManagement, section: 'forgot' },
    { path: '/reset', component: AuthenticationManagement, section: 'reset' },
    { path: '/set-password', component: AuthenticationManagement, section: 'set-password' }
  ]
};

export const appRoutes: Array<{ label: string; href: string; icon: iconMapKeys }> = [
  {
    label: 'Conversions',
    // icon: 'icon-park-outline',
    icon: 'conversion',
    href: '/call-to-action'
  },
  {
    label: 'Upload',
    icon: 'upload',
    href: '/upload-approve?status=approve'
  },
  {
    label: 'Assets',
    // icon: 'music-library',
    icon: 'assets',
    href: '/assets'
  },
  {
    label: 'Infra',
    // icon: 'ph_desktop',
    icon: 'feeds',
    href: '/infra'
  },
  {
    label: 'Feeds',
    icon: 'feeds',
    href: '/feeds'
  },
  {
    label: 'Experience',
    icon: 'curation',
    href: '/curations'
  },
  {
    label: 'Courses',
    icon: 'courses',
    href: '/courses'
  }
  // {
  //   label: 'Leads',
  //   icon: 'leads',
  //   href: '/leads'
  // }
];

export const analyticsAppRoutes: Array<{ label: string; href: string; icon: iconMapKeys }> = [
  {
    label: 'Engagement',
    // icon: 'archive',
    icon: 'analytics',
    href: '/analytics/engagement'
  },
  {
    label: 'Distribution',
    // icon: 'archive',
    icon: 'analytics',
    href: '/analytics/distribution'
  },
  {
    label: 'Skills',
    // icon: 'archive',
    icon: 'analytics',
    href: '/analytics/skills'
  }
  // {
  //   label: 'Leads',
  //   icon: 'leads',
  //   href: '/leads'
  // }
];
